export const iconPrimary = `var(--podium-cds-icon-button-color-bg-primary, var(--podium-cds-color-black))`;
export const iconPrimaryHover = `var(--podium-cds-icon-button-color-bg-primary-hover, var(--podium-cds-color-grey-500))`;
export const iconSecondary = `var(--podium-cds-icon-button-color-bg-secondary, var(--podium-cds-color-grey-100))`;
export const iconSecondaryHover = `var(--podium-cds-icon-button-color-bg-secondary-hover, var(--podium-cds-color-grey-300))`;
export const iconTertiaryHover = `var(--podium-cds-icon-button-color-bg-tertiary-hover, var(--podium-cds-color-grey-200))`;
export const iconTertiary = 'inherit';
